import { Component } from '@angular/core';

@Component({
  selector: 'app-main-refunds',
  templateUrl: './main-refunds.component.html',
  styleUrls: ['./main-refunds.component.css']
})
export class MainRefundsComponent {
  english:boolean=true;
  hindi:boolean=false;
  ngOnInit(): void {
    const storeVal = localStorage.getItem('selectedValue');
    if (storeVal == 'english') {
      this.english = true;
      this.hindi = false;
    }
    if (storeVal == 'hindi') {

      this.english = false;
      this.hindi = true;
    }

  }
}
